<div class="flex flex-col m-auto">
  <table mat-table [dataSource]="passages">
    <ng-container matColumnDef="jour">
      <th mat-header-cell *matHeaderCellDef class="no-bg"> </th>
      <td mat-cell *matCellDef="let passage"> {{passage.jour | weekDay}} </td>
    </ng-container>
  
    <ng-container matColumnDef="num_tournee">
      <th mat-header-cell *matHeaderCellDef class="icon"> Tournée </th>
      <td mat-cell *matCellDef="let passage" class="icon"><span *ngIf="passage.num_tournee">{{passage.num_tournee}}</span> </td>
    </ng-container>
  
    <ng-container matColumnDef="matin">
      <th mat-header-cell *matHeaderCellDef class="icon" > Matin </th>
      <td mat-cell *matCellDef="let passage" class="icon" ><i *ngIf="passage.matin" class="material-icons">check</i></td>
    </ng-container>
  
    <ng-container matColumnDef="apres_midi">
      <th mat-header-cell *matHeaderCellDef class="icon"> Après-midi </th>
      <td mat-cell *matCellDef="let passage" class="icon"><i *ngIf="passage.apres_midi" class="material-icons">check</i></td>
    </ng-container>
  
    <ng-container matColumnDef="jrs_relivraison_vt">
      <th mat-header-cell *matHeaderCellDef> VT </th>
      <td mat-cell *matCellDef="let passage"> {{passage.jrs_relivraison_vt | weekDay}} </td>
    </ng-container>
  
    <ng-container matColumnDef="jrs_relivraison_lp">
      <th mat-header-cell *matHeaderCellDef> LP </th>
      <td mat-cell *matCellDef="let passage"> {{passage.jrs_relivraison_lp | weekDay}} </td>
    </ng-container>
  
    <ng-container matColumnDef="jrs_relivraison_sa">
      <th mat-header-cell *matHeaderCellDef> Hygiène </th>
      <td mat-cell *matCellDef="let passage"> {{passage.jrs_relivraison_sa | weekDay}} </td>
    </ng-container>
  
    <ng-container matColumnDef="sep">
      <th mat-header-cell *matHeaderCellDef class="sep"> </th>
      <td mat-cell *matCellDef="let passage" class="sep"> </td>
    </ng-container>
  
    <ng-container matColumnDef="collect">
      <th mat-header-cell colspan="3" *matHeaderCellDef><h3>Jour de ramassage</h3></th>
    </ng-container>
  
    <ng-container matColumnDef="delivery">
      <th mat-header-cell colspan="3" *matHeaderCellDef><h3>Jours de livraison</h3></th>
    </ng-container>
  
    <tr mat-header-row class="sup-headers" *matHeaderRowDef="['sep','collect','sep','delivery']"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <p class="text-center">Le jour de livraison indique le départ de notre tournée logistique, le passage de l’agent de distribution peut varier en fonction des contraintes logistiques de la tournée. Les jours fériés peuvent également avoir une incidence sur votre jour de livraison. Si tel est le cas, nous vous communiquerons le changement 15 jours avant.</p>  
</div>
